import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../environments/environment.development';
import { BrowserInfo } from '../interfaces/common.interface';
import { StorageService } from './storage.service';

@Injectable({
  providedIn: 'root',
})
export class BaseService {
  private _getTime = `${environment.base_url}/api/Time`;
  protected readonly _http: HttpClient;
  protected readonly _storage: StorageService;
  constructor() {
    this._http = inject(HttpClient);
    this._storage = inject(StorageService);
  }
  public getTime() {
    return this._http.get<any>(this._getTime, {
      responseType: 'string',
    } as any);
  }
  public serializeData(obj: { [id: string]: string }) {
    var str = [];
    for (var p in obj)
      if (obj.hasOwnProperty(p) && obj[p].trim()) {
        str.push(
          encodeURIComponent(p) + '=' + encodeURIComponent(obj[p].trim())
        );
      }
    return `?${str.join('&')}`;
  }
  getBrowserAndOS(): BrowserInfo {
    const userAgent = navigator.userAgent;
    let browser = 'Unknown';
    let os = 'Unknown';
    console.log(userAgent);

    // Detect browser
    if (userAgent.includes('OPR') || userAgent.includes('Opera')) {
      browser = 'Opera';
    } else if (userAgent.includes('Edg')) {
      browser = 'Microsoft Edge';
    } else if (userAgent.includes('Chrome')) {
      browser = 'Chrome';
    } else if (userAgent.includes('Safari') && !userAgent.includes('Chrome')) {
      browser = 'Safari';
    } else if (userAgent.includes('Firefox')) {
      browser = 'Firefox';
    }

    // Detect operating system
    if (userAgent.includes('Windows')) {
      os = 'Windows';
    } else if (userAgent.includes('Mac OS X')) {
      os = 'macOS';
      const match = userAgent.match(/Mac OS X (\d+_\d+_\d+)/);
      os += match ? ` ${match[1].replace(/_/g, '.')}` : '';
    } else if (userAgent.includes('Linux')) {
      os = 'Linux';
    } else if (userAgent.includes('Android')) {
      os = 'Android';
      const match = userAgent.match(/Android (\d+\.\d+)/);
      os += match ? ` ${match[1]}` : '';
    } else if (userAgent.includes('iPhone') || userAgent.includes('iPad')) {
      os = 'iOS';
      const match = userAgent.match(/OS (\d+_\d+)/);
      os += match ? ` ${match[1].replace(/_/g, '.')}` : '';
    }

    return { browser, os };
  }
}
